import React from "react";
import styled from "styled-components";
import { IconButton } from "@material-ui/core";
import Icon from "@mdi/react";
import {
  mdiAlarmPlus,
  mdiAt,
  mdiPound,
  mdiClose,
  mdiEmoticon,
  mdiImage,
  mdiPaperclip,
} from "@mdi/js";
import useFooterLogic from "./useFooterLogic";
import useCacheDataMainTask from "hooks/useCacheDataMainTask";
import SendFileModal from "views/JobDetailPage/ChatComponent/SendFile/SendFileModal";
import StickerModal from "views/JobDetailPage/ChatComponent/StickerModal";
import TagModal from "views/JobDetailPage/ChatComponent/TagModal/TagModal";
import TagTaskModal from "views/JobDetailPage/ChatComponent/TagTaskModal";
import { TAG_TYPE } from "./constants";
import ChatBoxInput from "./ChatBoxInput";
import ReplyChatPreview from "./ReplyChatPreview";
import "../Chat.scss";
import "./styles.scss";

const StyledButton = styled.button`
  border: none;
  background-color: transparent;
  &:hover {
    color: ${(props) => props.hoverColor};
    background-color: #f6f6f6;
  }
  &:focus {
    outline: none;
  }
`;

const StyledChatBox = styled.div`
  .ChatBoxInput:focus {
    background-color: #fff;
    border-top: 1px solid ${(props) => props.borderColor};
  }
`;

const FooterPart = ({
  parentMessage,
  setSelectedChat,
  imagesQueue,
  setImagesQueue,
  setClickToBottom,
}) => {
  const tagTasks = useCacheDataMainTask("project.getTagProject.data", []);
  const {
    t,
    editorRef,
    sendButtonRef,
    groupActiveColor,
    visibleSendFile,
    chatText,
    isOpenMention,
    isOpenSticker,
    isShowQuickLike,
    imagesQueueUrl,
    membersFiltered,
    tagTasksFiltered,
    selectedId,
    selectedTagType,
    stickerKeyWord,
    setVisibleSendFile,
    setOpenMention,
    onpaste,
    handleTriggerUpload,
    handleUploadImage,
    onClickDeletePreview,
    openTag,
    handleCloseTag,
    onClickOpenSticker,
    handleCloseSticker,
    handleClickSticker,
    onClickRemind,
    handleClickMention,
    focus,
    handleUploadFile,
    sendMessage,
    onChooseMention,
    onDeleteChar,
    onOpenMention,
    onPressDown,
    onPressUp,
    onChangeChatText,
    cancelReply,
    onConfirmShare,
  } = useFooterLogic({
    parentMessage,
    setSelectedChat,
    imagesQueue,
    setImagesQueue,
    tagTasks,
  });

  return (
    <div className="footer-chat-container">
      <div className="wrap-function-bar-fp">
        <div>
          <abbr title={t("LABEL_CHAT_TASK_TAG_THANH_VIEN")}>
            <StyledButton
              className="icon-btn"
              onClick={() => {
                selectedTagType.current = TAG_TYPE.MEMBER;
                openTag();
              }}
              hoverColor={groupActiveColor}
            >
              <Icon path={mdiAt} size={1.2} />
            </StyledButton>
          </abbr>
          <abbr title={t("LABEL_CHAT_TASK_TAG_TASK")}>
            <StyledButton
              className="icon-btn"
              onClick={() => {
                selectedTagType.current = TAG_TYPE.TASK;
                openTag();
              }}
              hoverColor={groupActiveColor}
            >
              <Icon path={mdiPound} size={1.2} />
            </StyledButton>
          </abbr>
          <abbr title={t("LABEL_CHAT_TASK_GUI_STICKER")}>
            <StyledButton
              className="icon-btn"
              onClick={onClickOpenSticker}
              hoverColor={groupActiveColor}
            >
              <Icon path={mdiEmoticon} size={1.2} />
            </StyledButton>
          </abbr>
          <abbr title={t("LABEL_CHAT_TASK_GUI_ANH")}>
            <StyledButton
              className="icon-btn"
              onClick={() => handleTriggerUpload("upload_image")}
              hoverColor={groupActiveColor}
            >
              <input
                name="image"
                type="file"
                id="upload_image"
                className="hide"
                accept="image/*"
                multiple
                onChange={handleUploadImage}
              />
              <Icon path={mdiImage} size={1.2} />
            </StyledButton>
          </abbr>
          <abbr title={t("LABEL_CHAT_TASK_GUI_FILE_TAI_LIEU")}>
            <StyledButton
              className="icon-btn"
              onClick={() => setVisibleSendFile(true)}
              hoverColor={groupActiveColor}
            >
              <Icon path={mdiPaperclip} size={1.2} />
            </StyledButton>
          </abbr>
          <abbr title={t("LABEL_CHAT_TASK_THEM_NHAC_HEN")}>
            <StyledButton
              className="icon-btn"
              onClick={onClickRemind}
              hoverColor={groupActiveColor}
            >
              <Icon path={mdiAlarmPlus} size={1.2} />
            </StyledButton>
          </abbr>
        </div>
      </div>
      {parentMessage && (
        <ReplyChatPreview {...parentMessage} cancelReply={cancelReply} />
      )}
      {imagesQueueUrl.length ? (
        <div className="chatBox--preview">
          {imagesQueueUrl.map(({ url, name }, i) => (
            <div key={i} className="chatBox--imagePreviewWrap">
              <img className="chatBox--imagePreview" src={url} alt="hd" />
              <IconButton
                className="chatBox--imagePreviewDelete"
                onClick={onClickDeletePreview(i)}
              >
                <Icon path={mdiClose} size={0.6} />
              </IconButton>
              <div className="chatBox--namePreview">{name}</div>
            </div>
          ))}
        </div>
      ) : null}
      <StyledChatBox
        className="chatBox"
        id="input_message"
        borderColor={groupActiveColor}
        onClick={focus}
        onPaste={onpaste}
      >
        <ChatBoxInput
          placeholder={t("LABEL_CHAT_TASK_NHAP_GOI_Y_NOI_MESSAGE")}
          innerRef={editorRef}
          value={chatText}
          onChange={onChangeChatText}
          onPressUp={onPressUp}
          isOpenMention={isOpenMention}
          onChooseMention={onChooseMention}
          onOpenMention={onOpenMention}
          setOpenMention={setOpenMention}
          onDeleteChar={onDeleteChar}
          onPressDown={onPressDown}
          onSendMessage={() => {
            sendMessage();
            setClickToBottom();
          }}
          sendButtonRef={sendButtonRef}
          groupActiveColor={groupActiveColor}
          labelButton={t("LABEL_CHAT_TASK_GUI")}
          isShowQuickLike={isShowQuickLike}
          memberTagSelected={membersFiltered[selectedId] ? true : false}
          tagTasksFiltered={tagTasksFiltered[selectedId] ? true : false}
        />
      </StyledChatBox>
      {selectedTagType.current === TAG_TYPE.MEMBER && (
        <TagModal
          isOpen={isOpenMention}
          handleClose={handleCloseTag}
          handleClickMention={handleClickMention}
          selectedId={selectedId}
          members={membersFiltered}
        />
      )}
      {selectedTagType.current === TAG_TYPE.TASK && (
        <TagTaskModal
          isOpen={isOpenMention}
          handleClose={handleCloseTag}
          handleClickMention={handleClickMention}
          selectedId={selectedId}
          tagTasks={tagTasksFiltered}
        />
      )}
      {isOpenSticker && (
        <StickerModal
          isOpen={isOpenSticker}
          handleClose={handleCloseSticker}
          handleClickSticker={handleClickSticker}
          stickerKeyWord={stickerKeyWord}
        />
      )}
      <SendFileModal
        open={visibleSendFile}
        setOpen={setVisibleSendFile}
        onConfirmShare={onConfirmShare}
        handleUploadFile={handleUploadFile}
      />
    </div>
  );
};

export default React.memo(FooterPart);
